<div class="light-shade box rounded-corners" style="width: 100%">
  <div style="padding: 10px">
    <div style="display: flex">
      <div>
        <table>
          <tbody>
            <tr>
              <td class="payment-label">Total Balance to Pay:</td>
              <td style="text-align: right; width: 100px">
                {{ ccInfo.payment_amount | currency: 'USD':'symbol' }}
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="payment-label">Service Fee:</td>
              <td style="text-align: right">
                {{ processingFee | currency: 'USD':'symbol' }}
              </td>
            </tr>
            <tr>
              <td class="payment-label" style="text-align: right"></td>
              <td style="text-align: right">
                <div style="width: 100px; border-top: 2px solid black"></div>
              </td>
              <td></td>
            </tr>
            <tr>
              <td class="payment-label">Final Payment Amount:</td>
              <td style="text-align: right">
                {{ totalWithFee | currency: 'USD':'symbol' }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- (c) 2005, 2013. Authorize.Net is a registered trademark of CyberSource
      Corporation -->
      <div class="AuthorizeNetSeal">
        <script type="text/javascript" language="javascript">
          var ANS_customer_id = 'fe516600-8833-4ae8-8dd2-f672aff4a4fe';
        </script>
        <a
          href="https://verify.authorize.net/anetseal/?pid=fe516600-8833-4ae8-8dd2-f672aff4a4fe&rurl=https://surecourt.com/"
          onMouseOver="window.status='http://www.authorize.net/';return true;"
          onMouseOut="window.status='';return true;"
          onClick="window.open('https://verify.authorize.net/anetseal/?pid=fe516600-8833-4ae8-8dd2-f672aff4a4fe&rurl=https://surecourt.com/','AuthorizeNetVerification','width=600,height=430,dependent=yes,resizable=yes,scrollbars=yes,menubar=no,toolbar=no,status=no,directories=no,location=yes'); return false;"
          rel="noopener noreferrer"
          target="_blank"
          ><img
          src="https://verify.authorize.net/anetseal/images/secure90x72.gif"
          alt="Authorize.Net Merchant - Click to Verify"
        /></a>
      </div>
      <div [ngClass]="messageClass()" style="margin-left: 10px">
        <dx-validation-summary [validationGroup]="validationGroup"></dx-validation-summary>
        @for (item of messages; track item; let i = $index) {
          <div>
            {{ item }}
          </div>
        }
      </div>
    </div>
    <div style="margin-top: 10px">
      <dx-button
        text="Back"
        (onClick)="back()"
        icon="{{ env.assetsPath }}images/Left_Green_Circle-16x16.png"
      ></dx-button>
      <dx-button
        text="Confirm Payment"
        style="margin-left: 10px"
        (onClick)="confirmPaymentCheck()"
        [disabled]="!allowInput || !feeReady"
        icon="{{ env.assetsPath }}images/credit_card_16x16.png"
      ></dx-button>
      <dx-button
        text="Cancel"
        style="margin-left: 10px"
        icon="{{ env.assetsPath }}images/Cancel_16x16.png"
        (onClick)="cancel()"
        [disabled]="!allowInput"
      ></dx-button>
    </div>
  </div>
</div>
<app-confirm-payment-dialog #confirmPayment (completed)="onPaymentConfirmation($event)"></app-confirm-payment-dialog>

